// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/external_tickets/v1/external_tickets.proto" (package "c1.api.external_tickets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { TicketSchema } from "../../../connector/v2/ticket";
/**
 * @generated from protobuf message c1.api.external_tickets.v1.DeleteExternalTicketProvisionerConfigRequest
 */
export interface DeleteExternalTicketProvisionerConfigRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.DeleteExternalTicketProvisionerConfigResponse
 */
export interface DeleteExternalTicketProvisionerConfigResponse {
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.UpdateExternalTicketProvisionerConfigRequest
 */
export interface UpdateExternalTicketProvisionerConfigRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * @generated from protobuf field: string ticket_title_template = 4;
     */
    ticketTitleTemplate: string;
    /**
     * @generated from protobuf field: string ticket_body_template = 5;
     */
    ticketBodyTemplate: string;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketSchema ticket_schema = 6;
     */
    ticketSchema?: TicketSchema;
    /**
     * @generated from protobuf field: string error_status = 7;
     */
    errorStatus: string;
    /**
     * @generated from protobuf field: string success_status = 8;
     */
    successStatus: string;
    /**
     * @generated from protobuf field: string display_name = 9;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string label = 10;
     */
    label: string;
    /**
     * @generated from protobuf field: string ticket_type = 11;
     */
    ticketType: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.UpdateExternalTicketProvisionerConfigResponse
 */
export interface UpdateExternalTicketProvisionerConfigResponse {
    /**
     * @generated from protobuf field: c1.api.external_tickets.v1.ExternalTicketProvisionerConfig config = 1;
     */
    config?: ExternalTicketProvisionerConfig;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.GetConnectorExternalTicketProvisionerRequest
 */
export interface GetConnectorExternalTicketProvisionerRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.GetConnectorExternalTicketProvisionerResponse
 */
export interface GetConnectorExternalTicketProvisionerResponse {
    /**
     * @generated from protobuf field: c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner connector = 1;
     */
    connector?: ConnectorExternalTicketProvisioner;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ProcessExternalTicketForBulkActionRequest
 */
export interface ProcessExternalTicketForBulkActionRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ProcessExternalTicketForBulkActionResponse
 */
export interface ProcessExternalTicketForBulkActionResponse {
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ListConnectorExternalTicketProvisionerRequest
 */
export interface ListConnectorExternalTicketProvisionerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: bool exclude_no_ticket_schemas = 3;
     */
    excludeNoTicketSchemas: boolean;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ListConnectorExternalTicketProvisionerResponse
 */
export interface ListConnectorExternalTicketProvisionerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner list = 1;
     */
    list: ConnectorExternalTicketProvisioner[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.CreateExternalTicketProvisionerConfigRequest
 */
export interface CreateExternalTicketProvisionerConfigRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.CreateExternalTicketProvisionerConfigResponse
 */
export interface CreateExternalTicketProvisionerConfigResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ListExternalTicketProvisionerConfigRequest
 */
export interface ListExternalTicketProvisionerConfigRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 5;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.external_tickets.v1.ExternalTicketProvisionerConfigRef refs = 6;
     */
    refs: ExternalTicketProvisionerConfigRef[];
    /**
     * @generated from protobuf field: bool exclude_empty_ticket_schema = 7;
     */
    excludeEmptyTicketSchema: boolean;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ListExternalTicketProvisionerConfigResponse
 */
export interface ListExternalTicketProvisionerConfigResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_tickets.v1.ExternalTicketProvisionerConfig list = 1;
     */
    list: ExternalTicketProvisionerConfig[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.GetExternalTicketProvisionerConfigRequest
 */
export interface GetExternalTicketProvisionerConfigRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.GetExternalTicketProvisionerConfigResponse
 */
export interface GetExternalTicketProvisionerConfigResponse {
    /**
     * @generated from protobuf field: c1.api.external_tickets.v1.ExternalTicketProvisionerConfig config = 1;
     */
    config?: ExternalTicketProvisionerConfig;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner
 */
export interface ConnectorExternalTicketProvisioner {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketSchema ticket_schemas = 7;
     */
    ticketSchemas: TicketSchema[];
    /**
     * @generated from protobuf field: string display_name = 8;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ExternalTicketProvisionerConfig
 */
export interface ExternalTicketProvisionerConfig {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 4;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string ticket_title_template = 8;
     */
    ticketTitleTemplate: string;
    /**
     * @generated from protobuf field: string ticket_body_template = 9;
     */
    ticketBodyTemplate: string;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketSchema ticket_schema = 10;
     */
    ticketSchema?: TicketSchema;
    /**
     * @generated from protobuf field: string error_status = 11;
     */
    errorStatus: string;
    /**
     * @generated from protobuf field: string success_status = 12;
     */
    successStatus: string;
    /**
     * @generated from protobuf field: string display_name = 13;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string label = 14;
     */
    label: string;
    /**
     * @generated from protobuf field: string ticket_type = 15;
     */
    ticketType: string;
    /**
     * @generated from protobuf field: bool out_of_date = 16;
     */
    outOfDate: boolean;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ExternalTicketProvisionerConfigRef
 */
export interface ExternalTicketProvisionerConfigRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ExternalTicketRef
 */
export interface ExternalTicketRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_id = 2;
     */
    externalTicketProvisionerConfigId: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ExternalTicket
 */
export interface ExternalTicket {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_id = 2;
     */
    externalTicketProvisionerConfigId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string external_ticket_id = 7;
     */
    externalTicketId: string;
    /**
     * @generated from protobuf field: string external_ticket_status = 8;
     */
    externalTicketStatus: string;
    /**
     * @generated from protobuf field: string external_ticket_url = 9;
     */
    externalTicketUrl: string;
    /**
     * @generated from protobuf field: c1.api.external_tickets.v1.ExternalTicketState state = 11;
     */
    state: ExternalTicketState;
    /**
     * @generated from protobuf field: string app_id = 12;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 13;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string internal_ticket_id = 14;
     */
    internalTicketId: string;
    /**
     * @generated from protobuf field: int32 attempts = 15;
     */
    attempts: number;
    /**
     * @generated from protobuf field: string last_error = 16;
     */
    lastError: string;
    /**
     * @generated from protobuf field: string external_ticket_status_display_name = 17;
     */
    externalTicketStatusDisplayName: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.GetExternalTicketRequest
 */
export interface GetExternalTicketRequest {
    /**
     * @generated from protobuf field: string provisioner_config_id = 1;
     */
    provisionerConfigId: string;
    /**
     * @generated from protobuf field: string external_ticket_id = 4;
     */
    externalTicketId: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.GetExternalTicketResponse
 */
export interface GetExternalTicketResponse {
    /**
     * @generated from protobuf field: c1.api.external_tickets.v1.ExternalTicket external_ticket = 1;
     */
    externalTicket?: ExternalTicket;
}
/**
 * @generated from protobuf enum c1.api.external_tickets.v1.ExternalTicketState
 */
export enum ExternalTicketState {
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_CREATING = 2;
     */
    CREATING = 2,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_FETCHING = 3;
     */
    FETCHING = 3,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_ERROR = 4;
     */
    ERROR = 4,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_PROCESSING = 5;
     */
    PROCESSING = 5,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_RESOLVED = 6;
     */
    RESOLVED = 6,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_FATAL_ERROR = 7;
     */
    FATAL_ERROR = 7,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_SKIPPED = 8;
     */
    SKIPPED = 8,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_CANCELLED = 9;
     */
    CANCELLED = 9
}
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExternalTicketProvisionerConfigRequest$Type extends MessageType<DeleteExternalTicketProvisionerConfigRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.DeleteExternalTicketProvisionerConfigRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.DeleteExternalTicketProvisionerConfigRequest
 */
export const DeleteExternalTicketProvisionerConfigRequest = new DeleteExternalTicketProvisionerConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExternalTicketProvisionerConfigResponse$Type extends MessageType<DeleteExternalTicketProvisionerConfigResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.DeleteExternalTicketProvisionerConfigResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.DeleteExternalTicketProvisionerConfigResponse
 */
export const DeleteExternalTicketProvisionerConfigResponse = new DeleteExternalTicketProvisionerConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExternalTicketProvisionerConfigRequest$Type extends MessageType<UpdateExternalTicketProvisionerConfigRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.UpdateExternalTicketProvisionerConfigRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "ticket_title_template", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "ticket_body_template", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "ticket_schema", kind: "message", T: () => TicketSchema },
            { no: 7, name: "error_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "success_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "ticket_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.UpdateExternalTicketProvisionerConfigRequest
 */
export const UpdateExternalTicketProvisionerConfigRequest = new UpdateExternalTicketProvisionerConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExternalTicketProvisionerConfigResponse$Type extends MessageType<UpdateExternalTicketProvisionerConfigResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.UpdateExternalTicketProvisionerConfigResponse", [
            { no: 1, name: "config", kind: "message", T: () => ExternalTicketProvisionerConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.UpdateExternalTicketProvisionerConfigResponse
 */
export const UpdateExternalTicketProvisionerConfigResponse = new UpdateExternalTicketProvisionerConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorExternalTicketProvisionerRequest$Type extends MessageType<GetConnectorExternalTicketProvisionerRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.GetConnectorExternalTicketProvisionerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.GetConnectorExternalTicketProvisionerRequest
 */
export const GetConnectorExternalTicketProvisionerRequest = new GetConnectorExternalTicketProvisionerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorExternalTicketProvisionerResponse$Type extends MessageType<GetConnectorExternalTicketProvisionerResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.GetConnectorExternalTicketProvisionerResponse", [
            { no: 1, name: "connector", kind: "message", T: () => ConnectorExternalTicketProvisioner }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.GetConnectorExternalTicketProvisionerResponse
 */
export const GetConnectorExternalTicketProvisionerResponse = new GetConnectorExternalTicketProvisionerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProcessExternalTicketForBulkActionRequest$Type extends MessageType<ProcessExternalTicketForBulkActionRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.ProcessExternalTicketForBulkActionRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ProcessExternalTicketForBulkActionRequest
 */
export const ProcessExternalTicketForBulkActionRequest = new ProcessExternalTicketForBulkActionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProcessExternalTicketForBulkActionResponse$Type extends MessageType<ProcessExternalTicketForBulkActionResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.ProcessExternalTicketForBulkActionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ProcessExternalTicketForBulkActionResponse
 */
export const ProcessExternalTicketForBulkActionResponse = new ProcessExternalTicketForBulkActionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorExternalTicketProvisionerRequest$Type extends MessageType<ListConnectorExternalTicketProvisionerRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.ListConnectorExternalTicketProvisionerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "exclude_no_ticket_schemas", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ListConnectorExternalTicketProvisionerRequest
 */
export const ListConnectorExternalTicketProvisionerRequest = new ListConnectorExternalTicketProvisionerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorExternalTicketProvisionerResponse$Type extends MessageType<ListConnectorExternalTicketProvisionerResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.ListConnectorExternalTicketProvisionerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorExternalTicketProvisioner },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ListConnectorExternalTicketProvisionerResponse
 */
export const ListConnectorExternalTicketProvisionerResponse = new ListConnectorExternalTicketProvisionerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExternalTicketProvisionerConfigRequest$Type extends MessageType<CreateExternalTicketProvisionerConfigRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.CreateExternalTicketProvisionerConfigRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.CreateExternalTicketProvisionerConfigRequest
 */
export const CreateExternalTicketProvisionerConfigRequest = new CreateExternalTicketProvisionerConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExternalTicketProvisionerConfigResponse$Type extends MessageType<CreateExternalTicketProvisionerConfigResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.CreateExternalTicketProvisionerConfigResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.CreateExternalTicketProvisionerConfigResponse
 */
export const CreateExternalTicketProvisionerConfigResponse = new CreateExternalTicketProvisionerConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExternalTicketProvisionerConfigRequest$Type extends MessageType<ListExternalTicketProvisionerConfigRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.ListExternalTicketProvisionerConfigRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalTicketProvisionerConfigRef },
            { no: 7, name: "exclude_empty_ticket_schema", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ListExternalTicketProvisionerConfigRequest
 */
export const ListExternalTicketProvisionerConfigRequest = new ListExternalTicketProvisionerConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExternalTicketProvisionerConfigResponse$Type extends MessageType<ListExternalTicketProvisionerConfigResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.ListExternalTicketProvisionerConfigResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalTicketProvisionerConfig },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ListExternalTicketProvisionerConfigResponse
 */
export const ListExternalTicketProvisionerConfigResponse = new ListExternalTicketProvisionerConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalTicketProvisionerConfigRequest$Type extends MessageType<GetExternalTicketProvisionerConfigRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.GetExternalTicketProvisionerConfigRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.GetExternalTicketProvisionerConfigRequest
 */
export const GetExternalTicketProvisionerConfigRequest = new GetExternalTicketProvisionerConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalTicketProvisionerConfigResponse$Type extends MessageType<GetExternalTicketProvisionerConfigResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.GetExternalTicketProvisionerConfigResponse", [
            { no: 1, name: "config", kind: "message", T: () => ExternalTicketProvisionerConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.GetExternalTicketProvisionerConfigResponse
 */
export const GetExternalTicketProvisionerConfigResponse = new GetExternalTicketProvisionerConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorExternalTicketProvisioner$Type extends MessageType<ConnectorExternalTicketProvisioner> {
    constructor() {
        super("c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "ticket_schemas", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketSchema },
            { no: 8, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner
 */
export const ConnectorExternalTicketProvisioner = new ConnectorExternalTicketProvisioner$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalTicketProvisionerConfig$Type extends MessageType<ExternalTicketProvisionerConfig> {
    constructor() {
        super("c1.api.external_tickets.v1.ExternalTicketProvisionerConfig", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "ticket_title_template", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "ticket_body_template", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "ticket_schema", kind: "message", T: () => TicketSchema },
            { no: 11, name: "error_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "success_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "ticket_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "out_of_date", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ExternalTicketProvisionerConfig
 */
export const ExternalTicketProvisionerConfig = new ExternalTicketProvisionerConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalTicketProvisionerConfigRef$Type extends MessageType<ExternalTicketProvisionerConfigRef> {
    constructor() {
        super("c1.api.external_tickets.v1.ExternalTicketProvisionerConfigRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ExternalTicketProvisionerConfigRef
 */
export const ExternalTicketProvisionerConfigRef = new ExternalTicketProvisionerConfigRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalTicketRef$Type extends MessageType<ExternalTicketRef> {
    constructor() {
        super("c1.api.external_tickets.v1.ExternalTicketRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "external_ticket_provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ExternalTicketRef
 */
export const ExternalTicketRef = new ExternalTicketRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalTicket$Type extends MessageType<ExternalTicket> {
    constructor() {
        super("c1.api.external_tickets.v1.ExternalTicket", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "external_ticket_provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "external_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "external_ticket_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "external_ticket_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "state", kind: "enum", T: () => ["c1.api.external_tickets.v1.ExternalTicketState", ExternalTicketState, "EXTERNAL_TICKET_STATE_"] },
            { no: 12, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "internal_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "attempts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "last_error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "external_ticket_status_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ExternalTicket
 */
export const ExternalTicket = new ExternalTicket$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalTicketRequest$Type extends MessageType<GetExternalTicketRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.GetExternalTicketRequest", [
            { no: 1, name: "provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "external_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.GetExternalTicketRequest
 */
export const GetExternalTicketRequest = new GetExternalTicketRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalTicketResponse$Type extends MessageType<GetExternalTicketResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.GetExternalTicketResponse", [
            { no: 1, name: "external_ticket", kind: "message", T: () => ExternalTicket }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.GetExternalTicketResponse
 */
export const GetExternalTicketResponse = new GetExternalTicketResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.external_tickets.v1.ExternalTickets
 */
export const ExternalTickets = new ServiceType("c1.api.external_tickets.v1.ExternalTickets", [
    { name: "ListConnectorExternalTicketProvisioner", options: { "authz.method": { role: "VIEWER" } }, I: ListConnectorExternalTicketProvisionerRequest, O: ListConnectorExternalTicketProvisionerResponse },
    { name: "CreateExternalTicketProvisionerConfig", options: { "authz.method": { role: "EDITOR" } }, I: CreateExternalTicketProvisionerConfigRequest, O: CreateExternalTicketProvisionerConfigResponse },
    { name: "ListExternalTicketProvisionerConfig", options: { "authz.method": { role: "VIEWER" } }, I: ListExternalTicketProvisionerConfigRequest, O: ListExternalTicketProvisionerConfigResponse },
    { name: "GetExternalTicketProvisionerConfig", options: { "authz.method": { role: "VIEWER" } }, I: GetExternalTicketProvisionerConfigRequest, O: GetExternalTicketProvisionerConfigResponse },
    { name: "GetConnectorExternalTicketProvisioner", options: { "authz.method": { role: "VIEWER" } }, I: GetConnectorExternalTicketProvisionerRequest, O: GetConnectorExternalTicketProvisionerResponse },
    { name: "UpdateExternalTicketProvisionerConfig", options: { "authz.method": { role: "EDITOR" } }, I: UpdateExternalTicketProvisionerConfigRequest, O: UpdateExternalTicketProvisionerConfigResponse },
    { name: "DeleteExternalTicketProvisionerConfig", options: { "authz.method": { role: "EDITOR" } }, I: DeleteExternalTicketProvisionerConfigRequest, O: DeleteExternalTicketProvisionerConfigResponse },
    { name: "GetExternalTicket", options: { "authz.method": { role: "VIEWER" } }, I: GetExternalTicketRequest, O: GetExternalTicketResponse },
    { name: "ProcessExternalTicketForBulkAction", options: { "authz.method": { role: "EDITOR" } }, I: ProcessExternalTicketForBulkActionRequest, O: ProcessExternalTicketForBulkActionResponse }
]);
